"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migrateDialogCharacters = void 0;
const cast_1 = require("../tests/fixtures/cast");
/**
 * This migration got introduced because we used to keep character data in the character object.
 * We are now instead storing the url to where the character data is stored
 */
const addressesById = (() => {
    const categories = Object.keys(cast_1.cast);
    const map = {};
    categories.forEach((category) => {
        const ids = Object.keys(cast_1.cast[category]);
        ids.forEach((id) => {
            const c = cast_1.cast[category][id];
            map[id] = c.contractAddress;
        });
    });
    return map;
})();
const migrateDialogCharacters = async (dialog) => {
    const characters = {};
    for (const charId of Object.keys(dialog.characters)) {
        const char = dialog.characters[charId];
        const address = addressesById[charId];
        const newId = `${address}:${charId}`;
        const metadataUrl = char.skeleton.replace('skeleton', 'metadata');
        characters[newId] = metadataUrl;
    }
    const branch = dialog.scenes.scene1.branches.start;
    const steps = branch.steps;
    const newSteps = steps.map((step) => {
        if (step.bubble && step.bubble.charID) {
            step.bubble.charID = `${addressesById[step.bubble.charID]}:${step.bubble.charID}`;
        }
        if (step.camera && step.camera.charID) {
            step.camera.charID = `${addressesById[step.camera.charID]}:${step.camera.charID}`;
        }
        if (step.gestures) {
            step.gestures = step.gestures.map((gesture) => {
                const updatedGesture = {
                    ...gesture,
                    charID: `${addressesById[gesture.charID]}:${gesture.charID}`,
                };
                if (updatedGesture.gesture) {
                    updatedGesture.gesture = updatedGesture.gesture.substr(updatedGesture.gesture.lastIndexOf('/') + 1);
                }
                return updatedGesture;
            });
        }
        return step;
    });
    const newBranchChar = branch.characters.map((c) => ({
        ...c,
        id: `${addressesById[c.id]}:${c.id}`,
    }));
    return {
        ...dialog,
        scenes: {
            ...dialog.scenes,
            scene1: {
                ...dialog.scenes.scene1,
                branches: {
                    ...dialog.scenes.scene1.branches,
                    start: {
                        ...dialog.scenes.scene1.branches.start,
                        characters: newBranchChar,
                        steps: newSteps,
                    },
                },
            },
        },
        characters,
    };
};
exports.migrateDialogCharacters = migrateDialogCharacters;
//# sourceMappingURL=migrateDialogCharacters.js.map